import { IRequestService } from "../../service/request/RequestService";
import { IRequestType } from "../../model/request/RequestType";

export default class UpdateRequestTypeInteractor {
  private requestService: IRequestService;

  constructor(requestService) {
    this.requestService = requestService;
  }

  async execute(requestType: IRequestType) {
    return this.requestService.updateRequestType(requestType);
  }
}
